import { Spacer } from '@vinted/web-ui'

import { Skeleton } from '@marketplace-web/common-components/skeleton-ui'

import ItemsGridSkeleton from '../../components/ItemsGridSkeleton'

const FeedSectionLayoutSkeleton = () => {
  return (
    <>
      <Spacer size={Spacer.Size.XLarge} />
      <Skeleton width="50%" height={22} />
      <Spacer size={Spacer.Size.Medium} />
      <ItemsGridSkeleton />
    </>
  )
}

export default FeedSectionLayoutSkeleton
